import React, { forwardRef, useMemo, useContext } from 'react';
import { ReactEditor, useSlateStatic } from 'slate-react';

import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';
import Show from 'components/Show';

import { EditorContext } from 'components/Editor';

const Question = forwardRef(({ children, element, ...attributes }, ref) => {
	// Get editor's instance
	const editor = useSlateStatic();

	// Use editor's context
	const { quiz } = useContext(EditorContext);

	// Handle question addition
	const onAdd = () => {
		const path = ReactEditor.findPath(editor, element);
		editor.insertQuizOption(path);
	};

	// Handle question addition
	const onRemove = () => {
		const path = ReactEditor.findPath(editor, element);
		editor.deleteQuizQuestion(path);
	};

	return (
		<div className="flex flex-col space-y-3 w-full">
			{/* Question's title */}
			<div contentEditable={false} className="flex items-center">
				<Title
					title="Jautājums"
					className="flex-1"
				/>

				{/* Show only if editable */}
				<Show if={quiz.mode === 'edit'}>
					<Button
						small
						square
						icon="delete"
						theme="danger"
						onClick={onRemove}
						className="font-normal"
					/>
				</Show>
			</div>

			{/* Question's content and options */}
			<div ref={ref} {...attributes} className="space-y-3">
				{children}
			</div>

			{/* Question's option addition */}
			{/* Show only if editable */}
			<Show if={quiz.mode === 'edit'}>
				<div contentEditable={false}>
					<Button
						icon="add"
						value="Pievienot atbilžu variantu"
						onClick={onAdd}
					/>
				</div>
			</Show>
		</div>
	);
});

export default Question;